import type {
  CookieItem,
  CookieList,
} from 'hb-react/shared/apps/CookieBanner/types';

export const getSectionsData = (
  Content: React.ForwardRefExoticComponent<{
    ref: any;
    cookieList: CookieItem[];
    typeDescription: string;
  }>,
  cookieList: CookieList,
  flagUoSatismeter: boolean,
) => {
  const sections = [
    {
      title: __('Required cookies (always active)'),
      type: 'required',
      checked: true,
      disabled: true,
      children: ({ ref }) => (
        <Content
          ref={ref}
          cookieList={cookieList.required}
          typeDescription={s__(
            'CookieBanner|Cookies that are essential for critical functionality to work on the platform.',
          )}
        />
      ),
    },
    {
      title: __('Functional cookies'),
      type: 'functional',
      checked: false,
      disabled: false,
      children: ({ ref }) => (
        <Content
          ref={ref}
          cookieList={cookieList.functional}
          typeDescription={s__(
            'CookieBanner|Cookies that enable functionality on the platform. Deactivating these may result in some features not being available to you.',
          )}
        />
      ),
    },
    {
      title: __('Tracking cookies'),
      type: 'tracking',
      checked: false,
      disabled: false,
      children: ({ ref }) => (
        <Content
          ref={ref}
          cookieList={cookieList.tracking}
          typeDescription={s__(
            'CookieBanner|Cookies used to gather analytics on user behaviour on the platform in order to make improvements to the user experience.',
          )}
        />
      ),
    },
  ];

  if (flagUoSatismeter && cookieList.thirdPartySurvey) {
    sections.push({
      title: __('Usage survey'),
      type: 'thirdPartySurvey',
      checked: true,
      disabled: false,
      children: ({ ref }) => (
        <Content
          ref={ref}
          cookieList={cookieList.thirdPartySurvey as CookieItem[]}
          typeDescription={s__(
            'CookieBanner|Cookies that enable us to improve our products and collect your opinions and suggestions. The processing is based on our legitimate interest.',
          )}
        />
      ),
    });
  }

  return sections;
};
